<h2 mat-dialog-title>{{selectedDataDef != null && selectedDataDef.Id > 0 ? 'Edit' : 'Add'}} Code</h2>
<mat-dialog-content>
  <div style="display: flex; flex-direction: column; padding-bottom:10px; width:450px;" *ngIf="selectedDataDef != null">
    <tyl-form-field label='Code' [fullWidth]='true' *ngIf="dataDefList.ShowCodeField">
      <input #codeRef matInput id='inpCodeName' type='text' [(ngModel)]='selectedDataDef.Code' [maxlength]="dataDefList.CodeMaxLength"
      [minlength]="dataDefList.CodeMinLength" [required]="codeRequired" [disabled]="viewOnly" />
    </tyl-form-field>
    <tyl-form-field label='Description' [fullWidth]='true' *ngIf="dataDefList.ShowDescriptionField">
      <input #descriptionRef matInput id='inpDescriptionName' type='text' [(ngModel)]='selectedDataDef.Description'
        [maxlength]="dataDefList.DescriptionMaxLength" required [disabled]="viewOnly" />
    </tyl-form-field>
    <tyl-form-field label="Abbreviation" [fullWidth]='true' *ngIf="dataDefList.ShowAbbreviationField">
      <input matInput id='inpAbbreviation' type='text' [(ngModel)]='selectedDataDef.Abbreviation' maxlength="50" [disabled]="viewOnly" />
    </tyl-form-field>
    <tyl-form-field label="State Reporting" [fullWidth]='true' *ngIf="dataDefList.StateReportingType > 0">
      <mat-select [(ngModel)]="selectedDataDef.StateReportingCodeId" name="ddlStateReportingCode"
        id="ddlStateReportingCode" [disabled]="viewOnly">
        <mat-option *ngFor="let code of stateReportingCodes" [value]="code.Id">
          {{ code.CodeDescription }}
        </mat-option>
      </mat-select>
    </tyl-form-field>
    <tyl-checkbox *ngIf="showUseForStateReporting" id='chkIsStateReporting'
      [(checked)]='selectedDataDef.IsStateReporting' (change)="StateReportingChange()" [disabled]="viewOnly"><span translate>State
        Reporting</span>
    </tyl-checkbox>
    <tyl-checkbox id='chkIsDefault' [(checked)]='selectedDataDef.IsDefault' *ngIf="dataDefList.ShowDefaultField" [disabled]="viewOnly"><span translate>Default</span>
    </tyl-checkbox>
    <tyl-form-field label='Status' style="padding-top:18px;" *ngIf="dataDefList.ShowStatusField"> 
      <mat-select id='ddlStatus' [(ngModel)]='selectedDataDef.Inactive' [disabled]="viewOnly">
        <mat-option [value]='false'>Active</mat-option>
        <mat-option [value]='true'>Inactive</mat-option>
      </mat-select>
    </tyl-form-field>
    <tyl-form-field *ngIf="showUseForStateReporting" label="State Identifier" [fullWidth]='true'>
      <input matInput id='inpStateIdentifier' type='text' [(ngModel)]='selectedDataDef.StateIdentifier' [disabled]="!selectedDataDef.IsStateReporting || viewOnly" maxlength="50" />
    </tyl-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class='flex-footer-left'>

  </div>
  <div class='flex-footer-right'>
    <error-prompt [errorList]="errors"></error-prompt>
    <tyl-button image="save.png" label="Save" (clickEvent)="saveClick()" [disabled]="viewOnly"></tyl-button>
    <tyl-button image="cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
  </div>
</mat-dialog-actions>